import { render } from "./ReferCodePage.vue?vue&type=template&id=1c1c7bc6&scoped=true"
import script from "./ReferCodePage.vue?vue&type=script&lang=js"
export * from "./ReferCodePage.vue?vue&type=script&lang=js"

import "./ReferCodePage.vue?vue&type=style&index=0&id=1c1c7bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1c7bc6"]])

export default __exports__